import SpinnerIcon from "../icons/SpinnerIcon";

export default function Spinner(props: {
  size: number;
  label: string;
  inline: boolean;
  className?: string;
}) {
  const { size, label, inline, className } = props;

  return (
    <div className={styles(inline, className)}>
      <SpinnerIcon height={size} />
      {label && <div>{label}</div>}
    </div>
  );
}

Spinner.defaultProps = {
  size: 48,
  label: "",
  inline: false,
};

function styles(inline, className) {
  return inline
    ? `c-spinner flex-row gap-2 text-secondary${
        className ? " " + className : ""
      }`
    : `c-spinner flex-column gap-2 text-secondary${
        className ? " " + className : ""
      }`;
}

// export default Spinner;
